import { useQuery } from '@tanstack/react-query';

import { QUERY_KEYS } from '@/v2/constants/QueryKeys';
import getPricing from '@rockalingua/shared/subscriptions/getPricing';
import useCurrentUser from '../../Auth/hooks/useCurrentUser.hook';

export default function useGetSubscriptionTypesQuery() {
  const { user } = useCurrentUser();
  const keepPrice = !!user?.data?.keepPrice;

  return useQuery({
    queryKey: [QUERY_KEYS.SUBSCRIPTION_TYPES, keepPrice],
    queryFn: async () => {
      const pricingData = getPricing(keepPrice);

      return Object.values(pricingData);
    },
    staleTime: Infinity,
    cacheTime: Infinity,
  });
}
